"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createDirectLineSpeechAdapters;

var _botframeworkDirectlinespeechSdk = require("botframework-directlinespeech-sdk");

function createDirectLineSpeechAdapters() {
  return _botframeworkDirectlinespeechSdk.createAdapters.apply(void 0, arguments);
}